/**
 * ColleagueFace — Face do colega numa figurinha: avatar montado, foto ou inicial.
 *
 * A escolha entre os três é a do `usePersonFace` (a mesma do `UserAvatar` do Dashboard, com a
 * queda para o avatar e a inicial quando a foto do S3 não carrega — comum entre 23k funcionários
 * com `avatar_type:1` e foto inexistente). Aqui fica só o desenho da figurinha.
 */

import React from 'react';
import Avatar from 'funifier-nice-avatar';

import { usePersonFace } from 'components/person-avatar';

interface ColleagueFaceProps {
  /** Foto do colega (player.image) */
  image?: { small?: { url?: string } } | null;
  /** Avatar nice-avatar do colega (player.extra.avatar) */
  avatar?: Record<string, any> | null;
  /** Tipo de avatar (player.extra.avatar_type): 0 = avatar, 1 = foto */
  avatarType?: number;
  /** Inicial do nome (último recurso) */
  initial: string;
  /** Lado do quadrado da face em px */
  size: number;
  /** Classe da inicial (estilo do container) */
  initialClassName?: string;
}

export function ColleagueFace({ image, avatar, avatarType, initial, size, initialClassName }: ColleagueFaceProps) {
  const face = usePersonFace({ image: image?.small?.url, avatar, avatarType });
  const dim = { width: `${size}px`, height: `${size}px` };

  if (face.kind === 'avatar') {
    return <Avatar style={dim} {...face.avatar} />;
  }

  if (face.kind === 'photo') {
    return <img src={face.url} alt="" style={{ ...dim, objectFit: 'cover', borderRadius: '50%' }} onError={face.onError} />;
  }

  // último recurso: inicial sobre fundo roxo (padrão da casa), preenchendo o círculo
  return (
    <div
      className={initialClassName}
      style={{
        ...dim,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#7358c8',
        borderRadius: '50%',
      }}
    >
      {initial}
    </div>
  );
}
